import PropTypes from "prop-types";

const errorShape = PropTypes.shape({
  message: PropTypes.string.isRequired,
  errors: PropTypes.arrayOf(PropTypes.string),
});

export default errorShape;
